import styled from "styled-components";
import Select from "react-select";
import { device } from "../../../stylesheet/breakpoints";

export const SelectBox = styled(Select)`
  width: calc(100% - 2px);

  @media ${device.desktop} {
    width: 300px;
  }

  & .select__control {
    bottom: -1px;
    right: -1px;
    height: 52px;
    border-inline: 0.75px solid rgba(var(--bg-button-rgb), 0.35);
    border-top: 0.75px solid rgba(var(--bg-button-rgb), 0.35);
    border-bottom: 0.75px solid rgba(var(--bg-button-rgb), 0.35);
    border-radius: 3px;
    background-color: transparent;
    // box-shadow: none !important; /delete border for focus/

    @media ${device.desktop} {
      height: 42px;
    }

    & .select__value-container {
      padding: 15px 20px;

      @media ${device.desktop} {
        padding: 10px 20px;
      }
    }

    & .select__placeholder {
      font-weight: 400;
      font-size: 13px; //11
      line-height: 1.45;
      color: var(--text-color);
      padding: 0;
      margin: 0;

      @media ${device.desktop} {
        font-size: 13px; //10
        line-height: 1.6;
      }
    }

    & .select__input-container,
    & .select__single-value {
      font-weight: 400;
      font-size: 13px; //11
      line-height: 1.45;
      color: var(--text-color);
      padding: 0;
      margin: 0;

      @media ${device.desktop} {
        font-size: 13px; //10
        line-height: 1.6;
      }
    }

    & .select__indicator {
      color: var(--text-color);
    }

    & .select__indicator-separator {
      background-color: transparent;
    }

    &.select__control--is-focused {
      // border: none;
          
      &.select__control--menu-is-open {
        border-bottom: 0.75px solid var(--bg-color);
        border-radius: 3px 3px 0 0;
      }
    }
  }

  & .select__menu {
    width: 100%;
    margin-top: 0px;
    margin-left: 1px;
    padding: 2px 0;
    border: 0.75px solid rgba(var(--bg-button-rgb), 0.35);
    border-top: none;
    border-radius: 0 0 3px 3px;
    background-color: var(--bg-color);
    color: var(--text-color);
    box-shadow: none;
    font-weight: 400;
    font-size: 12px; //10
    line-height: 2.4;

    & .react-select__menu-list {
      width: 100%;
      padding: 0 20px;

      & .react-select__option {
        background-color: rgba(255, 255, 255, 0.07);
      }
    }
  }
`;
